import { cn } from 'cn'

interface UserAvatarProps {
  name: string
  src?: string | null
  className?: string
}

/** Round avatar: the user's photo when available, otherwise their initials. */
export function UserAvatar({ name, src, className }: UserAvatarProps) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')

  return (
    <span
      className={cn(
        'flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 text-xs font-semibold text-primary',
        className,
      )}
    >
      {src ? <img src={src} alt="" className="size-full object-cover" /> : <span aria-hidden>{initials}</span>}
    </span>
  )
}
